// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CollapseBase {\n  position: relative;\n  overflow: hidden;\n  transition: max-height 500ms ease;\n}\n.CollapseBase--expanded {\n  overflow: visible;\n}\n.CollapseBase--hidden {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
